import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from 'reactstrap';
import {validatePassword} from "../../../../api/api";
// eslint-disable-next-line import/no-unresolved
import {toast} from "react-toastify";


const PasswordConfirmationModal = ({ isOpen, onConfirm, onCancel, isConfirming, error, setError }: any) => {
  const [password, setPassword] = useState('');
  const [isValidating, setIsValidating] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleConfirm = async () => {
    if (!password) {
      if (setError) setError('La contraseña es requerida');
      return;
    }

    setIsValidating(true);
    if (setError) setError('');

    try {
      const response = await validatePassword(password) as any;

      const isValid = response.valid === true;

      if (isValid) {
        onConfirm(password);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      if (setError) setError('Error al validar la contraseña');
    } finally {
      setIsValidating(false);
    }
  };

  const handleCancel = () => {
    setPassword('');
    if (setError) setError('');
    onCancel();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel} centered>
      <ModalHeader toggle={handleCancel}>Confirmar Contraseña</ModalHeader>
      <ModalBody>
        <p>Por seguridad, por favor ingresa tu contraseña para guardar los cambios.</p>
        <FormGroup>
          <Label for="password">Contraseña</Label>

          <div className="position-relative">
            <Input
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e: any) => {
                  setPassword(e.target.value);
                  if (error && setError) setError('');
                }}
                invalid={!!error}
            />

            <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2 p-0"
                tabIndex={-1}
            >
              <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
            </button>
          </div>

          {error && <FormFeedback>{error}</FormFeedback>}
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={handleCancel} disabled={isConfirming}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={isConfirming || isValidating || !password.trim()}>
          {isValidating ? 'Validando...' : isConfirming ? 'Confirmando...' : 'Confirmar'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PasswordConfirmationModal;
